import { siteRoutes } from "../siteRoutesList";
import { FeedPage, SinglePostPage } from "@/features/feed";

export const feedRoutes = [
  // FEED/POSTS
  {
    element: FeedPage,
    path: siteRoutes["dashboard"],
  },
  {
    element: SinglePostPage,
    path: `${siteRoutes["singlePostAndSlug"]}:slug`,
  },
];
